var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChip8(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    role: "img",
    "aria-label": "CHIP-8 Emulator",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c8-screen",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0d2620"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#04100d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c8-glow",
    cx: 0.5,
    cy: 0.5,
    r: 0.55
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#6ee7d1",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#6ee7d1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c8-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c8-clip)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#c8-screen)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "url(#c8-glow)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6ee7d1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 29,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 29,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 29,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 35,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 35,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 41,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 53,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 65,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 65,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 65,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 29,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 29,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 29,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 35,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 35,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 41,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 41,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 47,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 53,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 53,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 59,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 65,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 65,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74,
    y: 65,
    width: 6,
    height: 6
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeOpacity: 0.22,
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 8,
    x2: 100,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 14,
    x2: 100,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 20,
    x2: 100,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 26,
    x2: 100,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 32,
    x2: 100,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 38,
    x2: 100,
    y2: 38
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 44,
    x2: 100,
    y2: 44
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 50,
    x2: 100,
    y2: 50
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 56,
    x2: 100,
    y2: 56
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 62,
    x2: 100,
    y2: 62
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 68,
    x2: 100,
    y2: 68
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 74,
    x2: 100,
    y2: 74
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 80,
    x2: 100,
    y2: 80
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 86,
    x2: 100,
    y2: 86
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 92,
    x2: 100,
    y2: 92
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip8);
export default __webpack_public_path__ + "static/media/chip-8.33cd7b5893a35bcae58c27a503c96990.svg";
export { ForwardRef as ReactComponent };